import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import { formatNumber } from 'utils/numberUtil';
import { ShowMorePopover } from 'views/Insights/insightsUtils';
import {noop} from 'lodash';
import './AnyaVisualizationPie.less';

const AnyaVisualizationPie = ({ showVisualization, visualisation, COLORS }) => {

    const getTotal = (data) => data.reduce((sum, entry) => sum + entry.value, 0);
    const totalValue = getTotal(visualisation?.data);
    const getColor = (entry, index) => entry.color || COLORS[index % COLORS?.length];
    const legendItems = visualisation?.data || [];

    const legendFormatter = (entry, index, _source) => {
        const entryData = legendItems.find(item => item.name === entry) || { name: entry, value: 0, color: getColor({ name: entry }, index) }
        const percentage = entryData.value ? ((entryData.value / totalValue) * 100).toFixed(1) : "0";
        const backgroundColor = getColor(entryData, index);
        
        return (
            <div className="anya-pie-legend-item">
                <div style={{backgroundColor: backgroundColor}}
                    className="anya-pie-legend-color"
                />
                <span 
                    title={`${entryData.name} (${percentage}%)`} 
                    className="text-ellipsis"
                >
                    {entryData.name} ({percentage}%)
                </span>
            </div>
        );
    };

    return showVisualization && (
        <div className="anya-pie-chart-wrapper">
            <h4>{visualisation.title}</h4>
            <div className="anya-pie-chart-content">
                    <PieChart width={300} height={300}>
                        <Pie
                            data={visualisation.data}
                            cx={150}
                            cy={150}
                            labelLine={false}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {visualisation.data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={getColor(entry, index)} />
                            ))}
                        </Pie>
                        <Tooltip formatter={formatNumber} />
                    </PieChart>
                    {ShowMorePopover(
                        legendItems,
                        null,
                        6, // Show first 6 items, then "+N" for overflow
                        noop,
                        undefined,
                        legendFormatter,
                        { wrapperStyle: { maxWidth: "100%" } }
                    )}
            </div>
        </div>
    )
};

export default AnyaVisualizationPie;